export default {"src":"/_next/static/media/img_promotion_section1.1e95d5db.svg","height":90,"width":360,"blurWidth":0,"blurHeight":0};